'use client';

import useUserContext from '@/hooks/useUserContext';
import { Customer } from '@/types/Auth';
import { getCookie } from 'cookies-next';
import React, { useEffect } from 'react';

// import { Container } from './styles';

const SetCustomer: React.FC<{ customer: Customer }> = ({ customer }) => {
  const { setLoggedCustomer } = useUserContext();
  const session = getCookie('PHPSESSID');

  useEffect(() => {
    if (!session) {
      fetch('/api/session', { method: 'POST' });
    }
    setLoggedCustomer(customer);
    // eslint-disable-next-line react-hooks/exhaustive-deps
  }, []);

  return <></>;
};

export default SetCustomer;
